import { useNavigate } from "react-router-dom";
import INTRO_IMG1 from "../../1.png";
import INTRO_IMG2 from "../../2.png";
import INTRO_IMG3 from "../../3.png";
import INTRO_IMG4 from "../../pre-order/image/3.png";

const OnboardingLiveOrderShortcut = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/boss/onboarding/live-sales");
  };

  return (
    <div className="w-full overflow-y-auto max-w-[480px] mx-auto bg-white">
      <div className="flex flex-col p-4 w-full space-y-6">
        <div className="space-y-2">
          <h1 className="text-4xl font-bold bg-blue-500 text-white inline px-4">
            실시간 판매
          </h1>
        </div>

        <div className="space-y-12">
          <div className="flex items-start">
            <div className="text-2xl font-bold bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-2">
              1
            </div>
            <h1 className="text-3xl font-bold">
              재고가 남았는데, <br /> 고객들에게 알려서 팔고 싶을 때!
            </h1>
          </div>
          <div className="flex justify-center items-center h-48">
            <img
              src={INTRO_IMG1}
              alt="실시간판매"
              className="max-h-56 bg-gray-200 rounded-2xl"
            />
          </div>
          <div className="flex items-start">
            <div className="text-2xl font-bold bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-2">
              2
            </div>
            <h1 className="text-3xl font-bold">
              사장님이 직접 메뉴 선택해서 올려요
            </h1>
          </div>
          <div className="flex justify-center items-center h-48">
            <img
              src={INTRO_IMG2}
              alt="실시간판매"
              className="max-h-56 bg-gray-200 rounded-2xl"
            />
          </div>
          <div className="flex items-start">
            <div className="text-2xl font-bold bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-2">
              3
            </div>
            <h1 className="text-3xl font-bold">
              소비자는 알림을 받고 <br /> 바로 구매하고 픽업하러 출발해요!
            </h1>
          </div>
          <div className="flex justify-center items-center h-48">
            <img
              src={INTRO_IMG3}
              alt="실시간판매"
              className="max-h-56 bg-gray-200 rounded-2xl"
            />
          </div>
          <div className="flex items-start">
            <div className="text-2xl font-bold bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-2">
              4
            </div>
            <h1 className="text-3xl font-bold">
              손님이 매장에 오면 상품을 전달해요.
            </h1>
          </div>
          <div className="flex justify-center items-center h-48">
            <img
              src={INTRO_IMG4}
              alt="실시간판매"
              className="max-h-56 bg-gray-200 rounded-2xl"
            />
          </div>
        </div>

        <button
          onClick={handleClick}
          className="max-w-[480px] mx-auto w-full py-3.5 bg-primary text-white font-semibold rounded-2xl transition duration-150 active:brightness-90 pointer-events-auto"
        >
          다음
        </button>
      </div>
    </div>
  );
};

export default OnboardingLiveOrderShortcut;
